import { request } from "services/api/util";

class CPBProductFullDescriptionService {
  async uploadCPBProductFullDescription(body) {
    let config;
    config = {
      method: "post",
      url: `admin/cpbProductFullDescription`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getCPBProductFullDescriptionResult(param) {
    const config = {
      method: "get",
      url: `admin/cpbProductFullDescription/result`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getListCPBProductFullDescription(param) {
    const config = {
      method: "get",
      url: `admin/cpbProductFullDescription`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new CPBProductFullDescriptionService();
